// TradingSkill DApp Mock Data & Utilities

export const MOCK_WALLET = {
  connected: false,
  address: "0x742d35Cc6634C0532925a3b8D4C9E2B3c1f2A4e8",
  shortAddress: "0x742d...A4e8",
  network: "BNB Chain",
  chainId: 56,
  isOldUser: true, // 是否为迁移老用户（决定支付方式）
};

/** AIFX 兑换历史占位项（接 API 后可替换为服务端数据） */
export interface MockAifxExchangeRecord {
  id: string;
  status: string;
  aifxAmount: string | number;
  aifAmount: string | number;
  time: string;
}

export const MOCK_AIFX_EXCHANGE_HISTORY: MockAifxExchangeRecord[] = [];
export const MOCK_STATS = {
  aifPrice: 0.0234,
  aifPriceChange: 12.5,
  totalAgentsSold: 847,
  totalAgentsLimit: 1000,
  yesterdayZoneVolume: 3200000,
  totalTvl: 12450000,
  totalUsers: 3842,
  totalTradeVolume: 28600000,
  aifMarketCap: 234000000,
  aifBuybackAmount: 1240000,
};

// 智能体类型定义 - 完全对齐 PRD
export const AGENT_TYPES = [
  {
    id: "pro1",
    name: "PRO 1",
    subtitle: "探索版",
    tagColor: "#22c55e",
    level: 1,
    basePrice: 1000, // 基础价格(U)，收益计算基准
    currentPrice: 1000, // 当前售价(U)，每5天涨3%最高18%
    fusdAmount: 300, // 混合支付 FUSD 部分
    usdtAmount: 700, // 混合支付 USDT 部分
    limitTotal: 500, // 首期限量
    remaining: 347, // 剩余
    // 四项权益
    boostRate: "10%", // 权益1: 托管加速
    releaseMultiple: 2, // 权益2: 基础释放(倍出局)
    aifTokenValue: 1200, // 权益3: TSK代币价值(U)，分200天发放
    teamLevel: "C1", // 权益4: 赠送团队等级（30天有效）
    // 计算字段
    totalValue: 500000, // 总价值 = 限量 × 价格
    dailyAifValue: 6, // 每日TSK价值 = aifTokenValue / 200
  },
  {
    id: "pro2",
    name: "PRO 2",
    subtitle: "进阶版",
    tagColor: "#22d3ee",
    level: 2,
    basePrice: 3000,
    currentPrice: 3000,
    fusdAmount: 900,
    usdtAmount: 2100,
    limitTotal: 300,
    remaining: 189,
    boostRate: "15%",
    releaseMultiple: 3,
    aifTokenValue: 4200,
    teamLevel: "C2",
    totalValue: 900000,
    dailyAifValue: 21,
  },
  {
    id: "pro3",
    name: "PRO 3",
    subtitle: "专业版",
    tagColor: "#d4a017",
    level: 3,
    basePrice: 5000,
    currentPrice: 5000,
    fusdAmount: 1500,
    usdtAmount: 3500,
    limitTotal: 100,
    remaining: 47,
    boostRate: "20%",
    releaseMultiple: 4,
    aifTokenValue: 5000,
    teamLevel: "C3",
    totalValue: 500000,
    dailyAifValue: 40,
  },
  {
    id: "pro4",
    name: "PRO 4",
    subtitle: "旗舰版",
    tagColor: "#f59e0b",
    level: 4,
    basePrice: 10000,
    currentPrice: 10000,
    fusdAmount: 3000,
    usdtAmount: 7000,
    limitTotal: 50,
    remaining: 0,
    boostRate: "25%",
    releaseMultiple: 5,
    aifTokenValue: 18000,
    teamLevel: "C4",
    totalValue: 500000,
    dailyAifValue: 90,
  },
  {
    id: "pro5",
    name: "PRO 5",
    subtitle: "创世版",
    tagColor: "#ef4444",
    level: 5,
    basePrice: 20000,
    currentPrice: 20000,
    fusdAmount: 6000,
    usdtAmount: 14000,
    limitTotal: 50,
    remaining: 12,
    boostRate: "30%",
    releaseMultiple: 6,
    aifTokenValue: 40000,
    teamLevel: "C5",
    totalValue: 1000000,
    dailyAifValue: 200,
  },
];

// 用户持有的智能体
export const MY_AGENTS = [
  {
    id: "agent-001",
    typeId: "pro3",
    name: "PRO 3",
    subtitle: "专业版",
    tagColor: "#d4a017",
    level: 3,
    status: "activated" as const, // "activated" | "inactive" | "exited"
    purchasePrice: 5000, // 购买时的基础价格
    purchaseDate: "2025-03-15",
    activatedAt: "2025-03-16",
    // 静态收益
    totalEarned: 1240, // 累计已发放
    maxEarnable: 20000, // 出局上限 = basePrice × releaseMultiple
    todayEarned: 60, // 今日静态收益
    dailyRate: "1.2%", // 当前日化
    // TSK 代币发放
    aifTotalValue: 8000, // TSK总价值(U)
    aifDaysCompleted: 22, // 已发放天数
    aifTotalDays: 200, // 总发放天数
    aifClaimedValue: 880, // 已领取TSK价值(U)
    // 团队等级
    giftedLevel: "C3",
    giftedLevelExpiry: "2025-04-15",
    // 硬件
    deliveryAddress: "上海市浦东新区张江高科技园区",
    deliveryStatus: "待发货",
    // 权益
    boostRate: "20%",
    releaseMultiple: 4,
  },
  {
    id: "agent-002",
    typeId: "pro1",
    name: "PRO 1",
    subtitle: "探索版",
    tagColor: "#22c55e",
    level: 1,
    status: "inactive" as const,
    purchasePrice: 1000,
    purchaseDate: "2025-04-01",
    activatedAt: null,
    totalEarned: 0,
    maxEarnable: 2000,
    todayEarned: 0,
    dailyRate: "0%",
    aifTotalValue: 1200,
    aifDaysCompleted: 0,
    aifTotalDays: 200,
    aifClaimedValue: 0,
    giftedLevel: null,
    giftedLevelExpiry: null,
    deliveryAddress: "",
    deliveryStatus: "待发货",
    boostRate: "10%",
    releaseMultiple: 2,
    // 混合支付欠款（老用户只付了70%U，还欠30%FUSD）
    fusdOwed: 300,
  },
];

// 智能体收益历史
export const AGENT_INCOME_HISTORY = [
  {
    date: "2025-04-07",
    amount: 60,
    rate: "1.2%",
    zoneVolume: "320万U",
    agentId: "agent-001",
  },
  {
    date: "2025-04-06",
    amount: 100,
    rate: "2%",
    zoneVolume: "215万U",
    agentId: "agent-001",
  },
  {
    date: "2025-04-05",
    amount: 60,
    rate: "1.2%",
    zoneVolume: "180万U",
    agentId: "agent-001",
  },
  {
    date: "2025-04-04",
    amount: 60,
    rate: "1.2%",
    zoneVolume: "120万U",
    agentId: "agent-001",
  },
  {
    date: "2025-04-03",
    amount: 60,
    rate: "1.2%",
    zoneVolume: "95万U",
    agentId: "agent-001",
  },
];

// AI 策略交易配置
export const AI_TRADING_CONFIG = {
  maxConcurrentOrders: 10, // 最大并存订单数
  maxOrdersPerCoin: 3, // 同一币种最多3单
  tradeFeeRate: 0.0012, // 交易手续费 0.12%
  computeFeeRate: 0.0015, // 算力费 0.15%
  strategyFetchCost: 2, // 获取策略费用 2U
  profitDisplayRatio: 0.7, // 盈利显示比例 70%
  tskxCompensationRate: 1, // 亏损补偿 1U=1TSKx
  withdrawFeeRate: 0.1, // 提现手续费 10% TSK
  autoTrade: {
    enabled: true,
    marginOptions: [200, 300, 400, 500],
    marginMin: 200,
    marginMax: 500,
    selectedMargin: 200,
    minLeverage: 5,
    selectedLeverage: 10,
    dailyOrderLimit: 15,
    todayOrderCount: 7,
  },
  manualTrade: {
    marginMin: 200,
    marginMax: 1000,
    minLeverage: 5,
  },
};

// 用户算力点数
export const MOCK_COMPUTE_POINTS = {
  purchased: 346, // 已购算力
  gifted: 4, // 赠送算力
  balance: 12.5, // 算力点数余额(U)
  fusdBalance: 320, // FUSD余额可用于支付
  totalConsumed: 87.5, // 累计消耗
  todayConsumed: 4.0, // 今日消耗
};

export const MOCK_ORDERS = [
  {
    id: "ord001",
    coin: "BTC",
    type: "多" as const,
    leverage: 10,
    margin: 300,
    totalPosition: 3000,
    openTime: "2026-04-17 09:23",
    pnl: 156.8,
    pnlDisplay: 109.76, // ×0.7
    status: "active" as const,
    strategy: "稳健保守型",
    orderSource: "auto" as const, // 自动下单
    tradeFee: 3.6, // 3000×0.12%
    computeFee: 4.5, // 3000×0.15%
    entryPrice: 75420,
    currentPrice: 75942,
    stopProfit: 76500,
    stopLoss: 74800,
  },
  {
    id: "ord002",
    coin: "BTC",
    type: "空" as const,
    leverage: 5,
    margin: 500,
    totalPosition: 2500,
    openTime: "2026-04-17 08:10",
    pnl: -42.5,
    pnlDisplay: -42.5, // 亏损原值
    status: "active" as const,
    strategy: "均衡交易型",
    orderSource: "manual" as const, // 手动下单
    tradeFee: 3.0,
    computeFee: 3.75,
    entryPrice: 75120,
    currentPrice: 75290,
    stopProfit: 74200,
    stopLoss: 75800,
  },
  {
    id: "ord003",
    coin: "BTC",
    type: "多" as const,
    leverage: 8,
    margin: 200,
    totalPosition: 1600,
    openTime: "2026-04-17 10:45",
    pnl: 28.3,
    pnlDisplay: 19.81,
    status: "active" as const,
    strategy: "谨慎进取型",
    orderSource: "auto" as const,
    tradeFee: 1.92,
    computeFee: 2.4,
    entryPrice: 75650,
    currentPrice: 75827,
    stopProfit: 76200,
    stopLoss: 75100,
  },
  // ─── ETH Running Orders ───
  {
    id: "ord004",
    coin: "ETH",
    type: "多" as const,
    leverage: 10,
    margin: 250,
    totalPosition: 2500,
    openTime: "2026-04-17 07:45",
    pnl: 87.5,
    pnlDisplay: 61.25,
    status: "active" as const,
    strategy: "稳健保守型",
    orderSource: "auto" as const,
    tradeFee: 3.0,
    computeFee: 3.75,
    entryPrice: 2280,
    currentPrice: 2315,
    stopProfit: 2380,
    stopLoss: 2220,
  },
  {
    id: "ord005",
    coin: "ETH",
    type: "空" as const,
    leverage: 8,
    margin: 180,
    totalPosition: 1440,
    openTime: "2026-04-17 11:30",
    pnl: -21.6,
    pnlDisplay: -21.6,
    status: "active" as const,
    strategy: "均衡交易型",
    orderSource: "manual" as const,
    tradeFee: 1.73,
    computeFee: 2.16,
    entryPrice: 2305,
    currentPrice: 2320,
    stopProfit: 2250,
    stopLoss: 2360,
  },
  // ─── BNB Running Order ───
  {
    id: "ord006",
    coin: "BNB",
    type: "多" as const,
    leverage: 5,
    margin: 400,
    totalPosition: 2000,
    openTime: "2026-04-17 06:20",
    pnl: 54.0,
    pnlDisplay: 37.8,
    status: "active" as const,
    strategy: "谨慎进取型",
    orderSource: "auto" as const,
    tradeFee: 2.4,
    computeFee: 3.0,
    entryPrice: 578,
    currentPrice: 593,
    stopProfit: 610,
    stopLoss: 560,
  },
  // ─── SOL Running Orders ───
  {
    id: "ord007",
    coin: "SOL",
    type: "多" as const,
    leverage: 15,
    margin: 200,
    totalPosition: 3000,
    openTime: "2026-04-17 09:50",
    pnl: 135.0,
    pnlDisplay: 94.5,
    status: "active" as const,
    strategy: "进取型",
    orderSource: "auto" as const,
    tradeFee: 3.6,
    computeFee: 4.5,
    entryPrice: 143.2,
    currentPrice: 147.7,
    stopProfit: 152.0,
    stopLoss: 139.5,
  },
  {
    id: "ord008",
    coin: "SOL",
    type: "空" as const,
    leverage: 10,
    margin: 150,
    totalPosition: 1500,
    openTime: "2026-04-17 12:15",
    pnl: -18.0,
    pnlDisplay: -18.0,
    status: "active" as const,
    strategy: "均衡交易型",
    orderSource: "manual" as const,
    tradeFee: 1.8,
    computeFee: 2.25,
    entryPrice: 146.8,
    currentPrice: 148.0,
    stopProfit: 142.0,
    stopLoss: 150.5,
  },
];

export const MOCK_HISTORY_ORDERS = [
  {
    id: "ord-h001",
    coin: "BTC",
    type: "多" as const,
    leverage: 10,
    margin: 300,
    totalPosition: 3000,
    openTime: "2026-04-16 11:10",
    pnl: 210.0,
    pnlDisplay: 147.0, // ×0.7
    closeTime: "2026-04-16 18:30",
    status: "profit" as const,
    orderSource: "auto" as const,
    tradeFee: 3.6,
    computeFee: 4.5,
    entryPrice: 74850,
    closePrice: 75550,
    finalAssets: {
      usdt: 82.32, // 56% USDT
      aif: 20.58, // 14% TSK
      aifx: 0,
    },
    // 盈利分配明细
    settlement: {
      rawProfit: 210.0,
      userProfit: 147.0, // 70%
      staticUsdt: 82.32, // 56%
      staticTsk: 20.58, // 14%
      dynamicUsdt: 23.52, // 16%
      dynamicTsk: 5.88, // 4%
      treasury: 7.35, // 5% TSK
      platform: 7.35, // 5% USDT
    },
  },
  {
    id: "ord-h002",
    coin: "BTC",
    type: "空" as const,
    leverage: 5,
    margin: 500,
    totalPosition: 2500,
    openTime: "2026-04-16 09:40",
    pnl: -75.0,
    pnlDisplay: -75.0,
    closeTime: "2026-04-16 14:15",
    status: "loss" as const,
    orderSource: "manual" as const,
    tradeFee: 3.0,
    computeFee: 3.75,
    entryPrice: 74920,
    closePrice: 75220,
    finalAssets: { usdt: 0, aif: 0, aifx: 75 },
    settlement: {
      rawLoss: -75.0,
      staticTskx: 75, // 100% 补偿
      dynamicTskx: 75, // 等量分配给动态
    },
  },
  {
    id: "ord-h003",
    coin: "BTC",
    type: "多" as const,
    leverage: 8,
    margin: 200,
    totalPosition: 1600,
    openTime: "2026-04-15 14:20",
    pnl: 64.0,
    pnlDisplay: 44.8,
    closeTime: "2026-04-15 22:10",
    status: "profit" as const,
    orderSource: "auto" as const,
    tradeFee: 1.92,
    computeFee: 2.4,
    entryPrice: 74200,
    closePrice: 74600,
    finalAssets: { usdt: 25.09, aif: 6.27, aifx: 0 },
    settlement: {
      rawProfit: 64.0,
      userProfit: 44.8,
      staticUsdt: 25.09,
      staticTsk: 6.27,
      dynamicUsdt: 7.17,
      dynamicTsk: 1.79,
      treasury: 2.24,
      platform: 2.24,
    },
  },
  {
    id: "ord-h004",
    coin: "BTC",
    type: "空" as const,
    leverage: 10,
    margin: 400,
    totalPosition: 4000,
    openTime: "2026-04-15 08:30",
    pnl: 180.0,
    pnlDisplay: 126.0,
    closeTime: "2026-04-15 16:45",
    status: "profit" as const,
    orderSource: "manual" as const,
    tradeFee: 4.8,
    computeFee: 6.0,
    entryPrice: 74800,
    closePrice: 74350,
    finalAssets: { usdt: 70.56, aif: 17.64, aifx: 0 },
    settlement: {
      rawProfit: 180.0,
      userProfit: 126.0,
      staticUsdt: 70.56,
      staticTsk: 17.64,
      dynamicUsdt: 20.16,
      dynamicTsk: 5.04,
      treasury: 6.3,
      platform: 6.3,
    },
  },
  {
    id: "ord-h005",
    coin: "BTC",
    type: "多" as const,
    leverage: 5,
    margin: 300,
    totalPosition: 1500,
    openTime: "2026-04-14 10:15",
    pnl: -22.5,
    pnlDisplay: -22.5,
    closeTime: "2026-04-14 15:30",
    status: "loss" as const,
    orderSource: "auto" as const,
    tradeFee: 1.8,
    computeFee: 2.25,
    entryPrice: 73900,
    closePrice: 73750,
    finalAssets: { usdt: 0, aif: 0, aifx: 22.5 },
    settlement: {
      rawLoss: -22.5,
      staticTskx: 22.5,
      dynamicTskx: 22.5,
    },
  },
  // ── ETH 历史订单 ──
  {
    id: "ord-h006",
    coin: "ETH",
    type: "多" as const,
    leverage: 10,
    margin: 400,
    totalPosition: 4000,
    openTime: "2026-04-16 10:05",
    pnl: 320.0,
    pnlDisplay: 224.0,
    closeTime: "2026-04-16 19:40",
    status: "profit" as const,
    orderSource: "auto" as const,
    tradeFee: 4.8,
    computeFee: 6.0,
    entryPrice: 2350,
    closePrice: 2430,
    finalAssets: { usdt: 125.44, aif: 31.36, aifx: 0 },
    settlement: {
      rawProfit: 320.0,
      userProfit: 224.0,
      staticUsdt: 125.44,
      staticTsk: 31.36,
      dynamicUsdt: 35.84,
      dynamicTsk: 8.96,
      treasury: 11.2,
      platform: 11.2,
    },
  },
  {
    id: "ord-h007",
    coin: "ETH",
    type: "空" as const,
    leverage: 8,
    margin: 300,
    totalPosition: 2400,
    openTime: "2026-04-15 16:30",
    pnl: -96.0,
    pnlDisplay: -96.0,
    closeTime: "2026-04-15 23:15",
    status: "loss" as const,
    orderSource: "manual" as const,
    tradeFee: 2.88,
    computeFee: 3.6,
    entryPrice: 2380,
    closePrice: 2420,
    finalAssets: { usdt: 0, aif: 0, aifx: 96 },
    settlement: {
      rawLoss: -96.0,
      staticTskx: 96,
      dynamicTskx: 96,
    },
  },
  {
    id: "ord-h008",
    coin: "ETH",
    type: "多" as const,
    leverage: 5,
    margin: 500,
    totalPosition: 2500,
    openTime: "2026-04-14 08:20",
    pnl: 125.0,
    pnlDisplay: 87.5,
    closeTime: "2026-04-14 17:50",
    status: "profit" as const,
    orderSource: "auto" as const,
    tradeFee: 3.0,
    computeFee: 3.75,
    entryPrice: 2310,
    closePrice: 2360,
    finalAssets: { usdt: 49.0, aif: 12.25, aifx: 0 },
    settlement: {
      rawProfit: 125.0,
      userProfit: 87.5,
      staticUsdt: 49.0,
      staticTsk: 12.25,
      dynamicUsdt: 14.0,
      dynamicTsk: 3.5,
      treasury: 4.375,
      platform: 4.375,
    },
  },
  {
    id: "ord-h009",
    coin: "ETH",
    type: "空" as const,
    leverage: 10,
    margin: 200,
    totalPosition: 2000,
    openTime: "2026-04-13 14:10",
    pnl: 160.0,
    pnlDisplay: 112.0,
    closeTime: "2026-04-13 21:30",
    status: "profit" as const,
    orderSource: "manual" as const,
    tradeFee: 2.4,
    computeFee: 3.0,
    entryPrice: 2400,
    closePrice: 2320,
    finalAssets: { usdt: 62.72, aif: 15.68, aifx: 0 },
    settlement: {
      rawProfit: 160.0,
      userProfit: 112.0,
      staticUsdt: 62.72,
      staticTsk: 15.68,
      dynamicUsdt: 17.92,
      dynamicTsk: 4.48,
      treasury: 5.6,
      platform: 5.6,
    },
  },
  {
    id: "ord-h010",
    coin: "ETH",
    type: "多" as const,
    leverage: 8,
    margin: 300,
    totalPosition: 2400,
    openTime: "2026-04-12 11:45",
    pnl: -48.0,
    pnlDisplay: -48.0,
    closeTime: "2026-04-12 18:20",
    status: "loss" as const,
    orderSource: "auto" as const,
    tradeFee: 2.88,
    computeFee: 3.6,
    entryPrice: 2290,
    closePrice: 2270,
    finalAssets: { usdt: 0, aif: 0, aifx: 48 },
    settlement: {
      rawLoss: -48.0,
      staticTskx: 48,
      dynamicTskx: 48,
    },
  },
  // ── BNB 历史订单 ──
  {
    id: "ord-h011",
    coin: "BNB",
    type: "多" as const,
    leverage: 10,
    margin: 300,
    totalPosition: 3000,
    openTime: "2026-04-16 13:20",
    pnl: 240.0,
    pnlDisplay: 168.0,
    closeTime: "2026-04-16 20:50",
    status: "profit" as const,
    orderSource: "auto" as const,
    tradeFee: 3.6,
    computeFee: 4.5,
    entryPrice: 580,
    closePrice: 604,
    finalAssets: { usdt: 94.08, aif: 23.52, aifx: 0 },
    settlement: {
      rawProfit: 240.0,
      userProfit: 168.0,
      staticUsdt: 94.08,
      staticTsk: 23.52,
      dynamicUsdt: 26.88,
      dynamicTsk: 6.72,
      treasury: 8.4,
      platform: 8.4,
    },
  },
  {
    id: "ord-h012",
    coin: "BNB",
    type: "空" as const,
    leverage: 5,
    margin: 400,
    totalPosition: 2000,
    openTime: "2026-04-15 09:15",
    pnl: -60.0,
    pnlDisplay: -60.0,
    closeTime: "2026-04-15 14:40",
    status: "loss" as const,
    orderSource: "manual" as const,
    tradeFee: 2.4,
    computeFee: 3.0,
    entryPrice: 575,
    closePrice: 590,
    finalAssets: { usdt: 0, aif: 0, aifx: 60 },
    settlement: {
      rawLoss: -60.0,
      staticTskx: 60,
      dynamicTskx: 60,
    },
  },
  {
    id: "ord-h013",
    coin: "BNB",
    type: "多" as const,
    leverage: 8,
    margin: 200,
    totalPosition: 1600,
    openTime: "2026-04-14 15:30",
    pnl: 96.0,
    pnlDisplay: 67.2,
    closeTime: "2026-04-14 22:10",
    status: "profit" as const,
    orderSource: "auto" as const,
    tradeFee: 1.92,
    computeFee: 2.4,
    entryPrice: 568,
    closePrice: 578,
    finalAssets: { usdt: 37.63, aif: 9.41, aifx: 0 },
    settlement: {
      rawProfit: 96.0,
      userProfit: 67.2,
      staticUsdt: 37.63,
      staticTsk: 9.41,
      dynamicUsdt: 10.75,
      dynamicTsk: 2.69,
      treasury: 3.36,
      platform: 3.36,
    },
  },
  {
    id: "ord-h014",
    coin: "BNB",
    type: "空" as const,
    leverage: 10,
    margin: 500,
    totalPosition: 5000,
    openTime: "2026-04-13 10:00",
    pnl: 350.0,
    pnlDisplay: 245.0,
    closeTime: "2026-04-13 18:30",
    status: "profit" as const,
    orderSource: "manual" as const,
    tradeFee: 6.0,
    computeFee: 7.5,
    entryPrice: 590,
    closePrice: 555,
    finalAssets: { usdt: 137.2, aif: 34.3, aifx: 0 },
    settlement: {
      rawProfit: 350.0,
      userProfit: 245.0,
      staticUsdt: 137.2,
      staticTsk: 34.3,
      dynamicUsdt: 39.2,
      dynamicTsk: 9.8,
      treasury: 12.25,
      platform: 12.25,
    },
  },
  {
    id: "ord-h015",
    coin: "BNB",
    type: "多" as const,
    leverage: 5,
    margin: 300,
    totalPosition: 1500,
    openTime: "2026-04-12 08:45",
    pnl: -37.5,
    pnlDisplay: -37.5,
    closeTime: "2026-04-12 13:20",
    status: "loss" as const,
    orderSource: "auto" as const,
    tradeFee: 1.8,
    computeFee: 2.25,
    entryPrice: 560,
    closePrice: 547.5,
    finalAssets: { usdt: 0, aif: 0, aifx: 37.5 },
    settlement: {
      rawLoss: -37.5,
      staticTskx: 37.5,
      dynamicTskx: 37.5,
    },
  },
  // ─── SOL History Orders ───
  {
    id: "ord-h-sol1",
    coin: "SOL",
    type: "多" as const,
    leverage: 10,
    margin: 250,
    totalPosition: 2500,
    openTime: "2026-04-17 10:30",
    pnl: 187.5,
    pnlDisplay: 131.25,
    closeTime: "2026-04-17 16:45",
    status: "profit" as const,
    orderSource: "auto" as const,
    tradeFee: 3.0,
    computeFee: 3.75,
    entryPrice: 145.2,
    closePrice: 152.7,
    finalAssets: { usdt: 73.5, aif: 18.38, aifx: 0 },
    settlement: {
      rawProfit: 187.5,
      userProfit: 131.25,
      staticUsdt: 73.5,
      staticTsk: 18.38,
      dynamicUsdt: 21.0,
      dynamicTsk: 5.25,
      treasury: 6.56,
      platform: 6.56,
    },
  },
  {
    id: "ord-h-sol2",
    coin: "SOL",
    type: "空" as const,
    leverage: 8,
    margin: 400,
    totalPosition: 3200,
    openTime: "2026-04-16 14:15",
    pnl: -96.0,
    pnlDisplay: -96.0,
    closeTime: "2026-04-16 20:30",
    status: "loss" as const,
    orderSource: "manual" as const,
    tradeFee: 3.84,
    computeFee: 4.8,
    entryPrice: 148.5,
    closePrice: 153.0,
    finalAssets: { usdt: 0, aif: 0, aifx: 96.0 },
    settlement: {
      rawLoss: -96.0,
      staticTskx: 96.0,
      dynamicTskx: 96.0,
    },
  },
  {
    id: "ord-h-sol3",
    coin: "SOL",
    type: "多" as const,
    leverage: 5,
    margin: 300,
    totalPosition: 1500,
    openTime: "2026-04-15 09:00",
    pnl: 67.5,
    pnlDisplay: 47.25,
    closeTime: "2026-04-15 15:20",
    status: "profit" as const,
    orderSource: "auto" as const,
    tradeFee: 1.8,
    computeFee: 2.25,
    entryPrice: 142.8,
    closePrice: 146.3,
    finalAssets: { usdt: 26.46, aif: 6.62, aifx: 0 },
    settlement: {
      rawProfit: 67.5,
      userProfit: 47.25,
      staticUsdt: 26.46,
      staticTsk: 6.62,
      dynamicUsdt: 7.56,
      dynamicTsk: 1.89,
      treasury: 2.36,
      platform: 2.36,
    },
  },
  {
    id: "ord-h-sol4",
    coin: "SOL",
    type: "空" as const,
    leverage: 15,
    margin: 200,
    totalPosition: 3000,
    openTime: "2026-04-14 11:45",
    pnl: 225.0,
    pnlDisplay: 157.5,
    closeTime: "2026-04-14 18:00",
    status: "profit" as const,
    orderSource: "auto" as const,
    tradeFee: 3.6,
    computeFee: 4.5,
    entryPrice: 151.2,
    closePrice: 143.7,
    finalAssets: { usdt: 88.2, aif: 22.05, aifx: 0 },
    settlement: {
      rawProfit: 225.0,
      userProfit: 157.5,
      staticUsdt: 88.2,
      staticTsk: 22.05,
      dynamicUsdt: 25.2,
      dynamicTsk: 6.3,
      treasury: 7.88,
      platform: 7.88,
    },
  },
  {
    id: "ord-h-sol5",
    coin: "SOL",
    type: "多" as const,
    leverage: 10,
    margin: 350,
    totalPosition: 3500,
    openTime: "2026-04-13 08:20",
    pnl: -52.5,
    pnlDisplay: -52.5,
    closeTime: "2026-04-13 14:10",
    status: "loss" as const,
    orderSource: "manual" as const,
    tradeFee: 4.2,
    computeFee: 5.25,
    entryPrice: 147.6,
    closePrice: 146.1,
    finalAssets: { usdt: 0, aif: 0, aifx: 52.5 },
    settlement: {
      rawLoss: -52.5,
      staticTskx: 52.5,
      dynamicTskx: 52.5,
    },
  },
];

// AI 交易统计汇总
export const MOCK_TRADING_STATS = {
  auto: {
    totalOrders: 42,
    profitOrders: 28,
    lossOrders: 14,
    winRate: 66.7,
    totalPnl: 1256.8,
    totalPnlDisplay: 879.76, // ×0.7 for profits
    todayPnl: 109.76,
    totalTskxCompensation: 185.0,
  },
  manual: {
    totalOrders: 18,
    profitOrders: 11,
    lossOrders: 7,
    winRate: 61.1,
    totalPnl: 534.2,
    totalPnlDisplay: 373.94,
    todayPnl: -42.5,
    totalTskxCompensation: 97.5,
  },
  lastSyncTime: "2026-04-17 11:23:45",
};

export const MOCK_CUSTODY_ORDERS = [
  {
    id: "cust-001",
    amount: 3000,
    depositTime: "2025-03-20 10:00",
    startEarningTime: "2025-03-21 10:00",
    redeemTime: null,
    redeemAvailableAt: null,
    status: "ongoing" as const,
    daysEarned: 17,
    totalEarned: 265.2,
    todayEarned: 15.6,
    pendingReward: 265.2,
    rewardSplit: {
      pendingUsdt: 185.64,
      pendingAif: 79.56,
      totalUsdt: 185.64,
      totalAif: 79.56,
      todayUsdt: 10.92,
      todayAif: 4.68,
    },
    monthlyRate: "52%",
  },
  {
    id: "cust-002",
    amount: 2000,
    depositTime: "2025-04-01 14:30",
    startEarningTime: "2025-04-02 14:30",
    redeemTime: null,
    redeemAvailableAt: null,
    status: "ongoing" as const,
    daysEarned: 5,
    totalEarned: 57.8,
    todayEarned: 11.6,
    pendingReward: 57.8,
    rewardSplit: {
      pendingUsdt: 40.46,
      pendingAif: 17.34,
      totalUsdt: 40.46,
      totalAif: 17.34,
      todayUsdt: 8.12,
      todayAif: 3.48,
    },
    monthlyRate: "52%",
  },
  {
    id: "cust-003",
    amount: 1000,
    depositTime: "2025-03-28 08:00",
    startEarningTime: "2025-03-29 08:00",
    redeemTime: "2025-04-06 10:15",
    redeemAvailableAt: "2025-04-07 10:15",
    status: "completed" as const,
    daysEarned: 8,
    totalEarned: 86.4,
    todayEarned: 0,
    pendingReward: 0,
    rewardSplit: {
      pendingUsdt: 0,
      pendingAif: 0,
      totalUsdt: 60.48,
      totalAif: 25.92,
      todayUsdt: 0,
      todayAif: 0,
    },
    monthlyRate: "52%",
  },
];

export const MOCK_CUSTODY = {
  monthlyQuota: 5000000,
  usedQuota: 3240000,
  minDeposit: 200,
  maxPerUser: 30000,
  baseMonthlyRate: "30%",
  boostRange: "10%",
  totalMonthlyRate: "30%",
  claimFeeRate: 0.1,
  reinvestMinAmount: 100,
  exitProfitDeduction: 0.5,
  exitPenalty: [
    { maxDays: 30, rate: 0.05 },
    { maxDays: 90, rate: 0.03 },
    { maxDays: Infinity, rate: 0 },
  ],
  lockHoursAfterExit: 24,
  // 已领取收益
  claimedUsdt: 242.5,
  claimedTsk: 58.3,
};

export const MOCK_ASSETS = {
  usdt: {
    available: 1842.5,
    custodyFrozen: 6000,
    tradingFrozen: 97.7,
    total: 7940.2,
  },
  fusd: {
    available: 320,
    total: 320,
    price: 1,
    gameBalance: 180,
    pendingWithdrawal: 140,
  },
  aif: { balance: 1250, price: 0.0234, usdValue: 29.25 },
  aifx: { balance: 3500, nextExchangeIn: "3天14小时" },
  todayPnl: +88.4,
  totalAssets: 8028.7,
};

export const MOCK_TRANSFER_HISTORY = [
  {
    id: "tx001",
    type: "充值",
    amount: 2000,
    asset: "USDT",
    time: "2025-04-05 14:23",
    status: "成功",
    txHash: "0xabc...123",
  },
  {
    id: "tx002",
    type: "提现",
    amount: 1000,
    asset: "USDT",
    aifFee: 200,
    time: "2025-04-03 09:11",
    status: "成功",
    txHash: "0xdef...456",
  },
  {
    id: "tx003",
    type: "划转",
    amount: 300,
    asset: "USDT",
    time: "2025-04-01 17:45",
    status: "成功",
    txHash: "0xghi...789",
  },
  {
    id: "tx004",
    type: "充值",
    amount: 5000,
    asset: "USDT",
    time: "2025-03-28 11:00",
    status: "成功",
    txHash: "0xjkl...012",
  },
  {
    id: "tx005",
    type: "提现",
    amount: 500,
    asset: "USDT",
    aifFee: 100,
    time: "2025-03-25 16:30",
    status: "成功",
    txHash: "0xmno...345",
  },
  {
    id: "tx006",
    type: "划转",
    amount: 150,
    asset: "USDT",
    time: "2025-03-22 10:15",
    status: "成功",
    txHash: "0xpqr...678",
  },
  {
    id: "tx007",
    type: "购买",
    amount: 320,
    asset: "FUSD",
    time: "2025-04-06 21:18",
    status: "成功",
    txHash: "0xstu...901",
  },
];

export const MOCK_TSKX_EXCHANGE_HISTORY = [
  {
    id: "ex001",
    aifxAmount: 500,
    aifAmount: 0.6,
    time: "2025-04-07 00:00",
    status: "成功",
  },
  {
    id: "ex002",
    aifxAmount: 350,
    aifAmount: 0.42,
    time: "2025-03-31 00:00",
    status: "成功",
  },
  {
    id: "ex003",
    aifxAmount: 280,
    aifAmount: 0.336,
    time: "2025-03-24 00:00",
    status: "成功",
  },
  {
    id: "ex004",
    aifxAmount: 420,
    aifAmount: 0.504,
    time: "2025-03-17 00:00",
    status: "成功",
  },
];

export const MOCK_TEAM = {
  level: "C5",
  levelNum: 5,
  personalDeposit: 5000,
  personalTarget: 10000,
  teamVolume: 1280000,
  teamVolumeTarget: 5000000,
  zoneVolume: 890000,
  directReferrals: 7,
  totalTeamSize: 58,
  validAccounts: 5,
  todayDynamicReward: 28.4,
  totalDynamicReward: 1240,
  pendingReward: 86.2,
};

export const MOCK_TEAM_MEMBERS = [
  {
    address: "0xFE...D27",
    level: "C6",
    totalVolume: 125000,
    newVolume: 3200,
    teamSize: 12,
    newTeamSize: 1,
    isValid: true,
  },
  {
    address: "0x78...331",
    level: "C3",
    totalVolume: 45000,
    newVolume: 800,
    teamSize: 5,
    newTeamSize: 0,
    isValid: true,
  },
  {
    address: "0xd7...Cb1",
    level: "C7",
    totalVolume: 380000,
    newVolume: 12000,
    teamSize: 28,
    newTeamSize: 3,
    isValid: true,
  },
  {
    address: "0x3b...06a",
    level: "C1",
    totalVolume: 3000,
    newVolume: 0,
    teamSize: 1,
    newTeamSize: 0,
    isValid: false,
  },
  {
    address: "0x51...C1d",
    level: "C4",
    totalVolume: 89000,
    newVolume: 5600,
    teamSize: 8,
    newTeamSize: 1,
    isValid: true,
  },
  {
    address: "0xF0...5ed",
    level: "C2",
    totalVolume: 12000,
    newVolume: 1200,
    teamSize: 3,
    newTeamSize: 0,
    isValid: true,
  },
  {
    address: "0x73...87C",
    level: "C1",
    totalVolume: 1000,
    newVolume: 0,
    teamSize: 1,
    newTeamSize: 0,
    isValid: false,
  },
  {
    address: "0xE7...533",
    level: "C3",
    totalVolume: 28000,
    newVolume: 2100,
    teamSize: 4,
    newTeamSize: 0,
    isValid: true,
  },
];

export const STATIC_INCOME_RECORDS = [
  { date: "2025-04-07", amount: 60, rate: "1.2%", zoneVolume: "320万U" },
  { date: "2025-04-06", amount: 100, rate: "2%", zoneVolume: "215万U" },
  { date: "2025-04-05", amount: 60, rate: "1.2%", zoneVolume: "180万U" },
  { date: "2025-04-04", amount: 60, rate: "1.2%", zoneVolume: "120万U" },
  { date: "2025-04-03", amount: 60, rate: "1.2%", zoneVolume: "95万U" },
];

export function formatNumber(n: number, decimals = 2): string {
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return n.toFixed(decimals);
}

export function formatUSDT(n: number): string {
  return n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function shortAddress(addr: string): string {
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
}
